
export default {
  /** 配置显示在浏览器标签的title **/
  title: '吉时牛',
  /** 公司名称 **/
  name: '杭州吉时牛科技有限公司',
  /** 公司微信 **/
  wechat: 'GZWjhsmart',
  /** 公司邮箱 **/
  email: 'liyebang2019@163.com',
  /** 公司手机 **/
  phone: '17310656552',
  /** 公司电话 **/
  tel: '021-18279700225',
  /** 公司地址 **/
  address: '浙江省杭州市上城区婺江路217号1号楼19层1906室',
  addressImg: 'https://bcsaas-1303249640.cos.ap-beijing.myqcloud.com/20240115153553007.png',
  /** 备案号 **/
  keepOnRecordIcp: '浙ICP备2025151307号-1'
}



// WEBPACK FOOTER //
// ./src/config/index.js